module.exports = __webpack_public_path__ + "img/15.5208d4ee.jpg";